<template>
<div class="layer-project" data-project-name="yb-tour"><!-- Project Name -->
    <div class="layer-project-detail">
        <!-- Page Contents -->
        <section class="project-visual">
            <div>
                <h1 class="project-tit">Yellow Balloon <br class="lb-m">Tour</h1>
                <a href="http://www.ybtour.co.kr" class="link" target="_blank">www.ybtour.co.kr</a>
            </div>
        </section>
        <!-- Details [s] -->
        <section class="project-overview">
            <div class="inner-section">
                <h2 class="project-overview-tit">Overview</h2>
                <p class="project-overview-txt">
                    <span>여행상품을 쉽고 빠르게 찾을 수 있도록 내비게이션 및 검색 기능을 강화하여 홈페이지를 개편했습니다. </span><span>운영의 효율성 및 마케팅 활용을 위해 다양한 관리 기능을 구현했습니다. </span><span>최신 디자인 트렌드를 반영하고 직관적인 UI(User Interface)를 제공합니다.</span>
                </p>
                <div class="project-overview-diagram">
                    <ul class="diagram01">
                        <li class="item01">Value <br class="lb-m"><br class="lb-t">Creating</li>
                        <li class="item02">Trustworthy</li>
                    </ul>
                    <ul class="diagram02">
                        <li class="item03">Innovation</li>
                        <li class="item04">Joyful</li>
                    </ul>
                    <ul class="diagram03">
                        <li class="item05">Yellow <br class="lb-t">Balloon<br>Tour</li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="section section01">
            <div class="inner-section">
                <div class="cont-tit-area">
                    <strong class="project-subtit">PC Web</strong>                    
                    <p class="cont-desc">전체적인 톤앤매너를 유지하면서 노랑풍선의 브랜드 컬러를 포인트로 사용하였으며, <br class="lb-t">많은 양의 정보를 쉽게 볼 수 있도록 Grid System을 적용하여 표현하였습니다. <br>타 경쟁사들과 다르게 세분화된 검색기능을 메인에 노출시켜 사용자들이 원하는 정보를 정확하고 빠르게 볼 수 있도록 구성하였습니다.</p>
                </div>
                <div class="detail-img"><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec1-img@m.png"></div>
            </div>
        </section>
        <section class="section section02 full">
            <div class="inner-section">
                <div class="content content01">
                    <div class="detail-img max-limit">
                        <img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content01-img@m.png">
                    </div>
                </div>
                <div class="content content02">
                    <div class="detail-img">
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content02-img01@m.jpg" data-break="m-tw"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content02-img02@m.jpg" data-break="m-tw"></p>
                    </div>
                </div>
                <div class="content content03">
                    <div class="detail-img max-limit">
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content03-img01@m.jpg"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content03-img02@m.jpg"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content03-img03@m.jpg"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content03-img04@m.jpg"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content03-img05@m.jpg"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec2-content03-img06@m.jpg"></p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section03 full">
            <div class="inner-section">
                <div class="content content01">
                    <div class="cont-tit-area max-limit">
                        <strong class="project-subtit">Mobile Web </strong>                    
                        <p class="cont-desc">각각의 콘텐츠 영역이 돋보일 수 있도록 <br class="lb-m">다양한 레이아웃으로 구성하였으며,<br>노랑풍선의 로고와 어울리는 아이콘들을 사용하여 <br>GNB 영역을 재미있게 표현하였습니다.</p>
                    </div>
                    <div class="detail-img"><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec3-content01-img@m.png" data-break="m-tw"></div>
                </div>
                <div class="content content02">
                    <div class="detail-img">
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec3-content02-img01@m.jpg" data-break="m-tw"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec3-content02-img02@m.jpg" data-break="m-tw"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec3-content02-img03@m.jpg" data-break="m-tw"></p>
                        <p><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec3-content02-img04@m.jpg" data-break="m-tw"></p>
                    </div>
                </div>                
                <div class="content content03">
                    <div class="detail-img"><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec3-content03-img@m.png"></div>
                </div>
            </div>
        </section>
        <section class="section section04 full">
            <div class="inner-section max-limit">
                <div class="cont-tit-area">
                    <p class="cont-tit"><img src="" alt="" data-src="/static/img/project-detail/ybTour/sec4-tit-img@m.png"></p>
                    <p class="cont-desc">노랑풍선은 2001년 설립과 함께 Global travel leader 기업이라는 비전을 향해 나아가고 있습니다. <br>창립 년도부터 지속적인 성장세와 매년 경영과제 설정을 통하여 업계에 괄목할 만한 <br class="lb-w">내실경영으로 성장해 왔습니다.
                    </p>
                </div>
                <div class="detail-cont cont02">
                    <ul>
                        <li data-color="#ffc72c">#ffc72c</li>
                        <li data-color="#ff5c46">#ff5c46</li>
                        <li data-color="#4567ad">#4567ad</li>
                    </ul>
                    <ul>
                        <li data-color="#222222">#222222</li>
                        <li data-color="#555555">#555555</li>
                        <li data-color="#777777">#777777</li>
                    </ul>
                </div>
            </div>
        </section>
        <!-- Details [e] -->
        <section class="project-client"><strong class="a11y-hidden">Yellow Balloon Tour</strong></section>
        <!-- Page Contents -->
    </div>

    
    <app-pjmove></app-pjmove>
</div>
</template>

<script>
import pjMove from '../components/pjMove.vue'
import projectCommon from '../assets/js/projectCommon.js'
export default {
    components: {
        'app-pjmove': pjMove
    },
    mixins: [projectCommon],
    mounted:function(){//onload
        this.projectInit();
    },  
}
</script>
<!-- css 추가 -->
<style>
    @import '../../static/css/projects.css'; /* Common Project Detail Page */
</style>
<style scoped>
    /* Common */
    /* .layer-project-detail > section.full{padding-bottom:0} */
    .section .cont-desc{word-break:keep-all}
    .section.full .con-tit-area{max-width:1280px;margin:0 auto}
    @media screen and (max-width:711px){
        .section.full .max-limit{padding:0 15px}
        .lb-m{display:block}
        .lb-t{display:none}
    }
    @media screen and (min-width:712px){
        .section.full .max-limit{padding:0 40px}
        .lb-m{display:none}
        .lb-t{display:block}
    }
    @media screen and (min-width:1280px){
        .section.full{max-width:1920px}
        .section.full .max-limit{max-width:1280px;margin:0 auto;padding-left:20px;padding-right:20px}
        .lb-t{display:none}
    }

    /* Project Visual, Project CI */
    .project-client{background:#fff url(/static/img/project-detail/ybTour/ci.png) 50%/auto 48px no-repeat}
        @media screen and (max-width:711px){
            .project-visual{background-image:url(/static/img/project-detail/ybTour/bg-overview@m.jpg)}        
        }
        @media screen and (min-width:712px){
            .project-visual{background-image:url(/static/img/project-detail/ybTour/bg-overview@t.jpg)}
        }
        @media screen and (min-width:1280px){
            .project-visual{background-image:url(/static/img/project-detail/ybTour/bg-overview@w.jpg)}
            .project-client{background-size:auto 135px}
        }
    
    /* Overview */
    .project-overview-txt span{display:block}
    .project-overview-diagram{display:flex;justify-content:center;align-items:center}
    .project-overview-diagram ul{position:relative;display:flex;justify-content:center}
    .project-overview-diagram ul li{display:inline-flex;justify-content:center;align-items:center;width:100px;height:100px;background-color:#f2f1ee;line-height:1.2;border-radius:50%;text-align:center;letter-spacing:-0.25px}
    .project-overview-diagram .diagram03 li{background-color:#fcc440}
        @media screen and (max-width:711px){
            .project-overview-txt span{margin-bottom:10px}
            .project-overview-diagram{display:block}
            .project-overview-diagram ul:not(.diagram03){flex-wrap:wrap}
            .project-overview-diagram ul:not(.diagram03) li{margin:0 6.25vw 21px}
            .project-overview-diagram .diagram01{margin-top:25px}
            .project-overview-diagram .diagram03 li{width:130px;height:130px;font-size:17px}
        }
        @media screen and (min-width:712px){
            .project-overview-txt span{line-height:1.6}
            .project-overview-diagram{margin-top:25px}
            .project-overview-diagram ul:not(.diagram03) li{margin-right:21px}
            .project-overview-diagram .diagram03{display:block;padding-left:48px}
            .project-overview-diagram .diagram03:before{content:'';position:absolute;top:50%;left:0;width:25px;height:1px;background-color:#000}
        }
        @media screen and (min-width:1280px){
            .project-overview-diagram{margin-top:45px}
            .project-overview-diagram ul{padding:20px 0}
            .project-overview-diagram ul li{width:200px;height:200px;font-size:20px}
            .project-overview-diagram ul:not(.diagram03) li{margin-right:30px}
            .project-overview-diagram .diagram03{padding-left:105px}
            .project-overview-diagram .diagram03 li{font-size:24px}
            .project-overview-diagram .diagram03:before{width:60px;height:2px;background-color:#000}
        }
    /* section01 : PC Web */
    .section01{background-color:#f2f1ee}
    .section01 .detail-img{border-radius:15px;overflow:hidden;text-align:center;box-shadow:0px 20px 30px 0px rgba(0, 0, 0, 0.16)}
        @media screen and (max-width:711px){
            .section01 .detail-img{margin-top:15px}
        }
        @media screen and (min-width:712px){
            .section01 .detail-img{margin-top:31px}
        }
        @media screen and (min-width:1280px){
            .section01 .detail-img{margin-top:53px;margin-bottom:80px;border-radius:20px}
        }
    /* section02 : PC Web detail */
    .layer-project-detail > .section02{padding-top:0}
    .section02 .content01 .detail-img{text-align:center}
    .section02 .content01{background-color:#222;padding:40px 0}
    .section02 .content02{background-color:#f2f1ee;overflow:hidden}
    .section02 .content02 .detail-img{position:relative;width:100%}
    .section02 .content02 .detail-img:after{content:'';position:absolute;bottom:0;left:0;z-index:20;width:100%;background: rgb(0,0,0);background:linear-gradient(0deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0) 100%);opacity:0.5}
    .section02 .content02 p{position:absolute;bottom:0}
    .section02 .content02 p img{box-shadow:11px 19px 40px 0px rgba(0, 0, 0, 0.19)}
    .section02 .content02 p:nth-child(1){z-index:10}
    .section02 .content03{background-color:#fff}
    .section02 .content03 .detail-img{display:flex;flex-wrap:wrap;justify-content:center;padding-top:40px}
    .section02 .content03 p{text-align:center}
        @media screen and (max-width:711px){
            .section02 .content02{padding-top:25px}
            .section02 .content02 .detail-img{height:61.71875vw}
            .section02 .content02 .detail-img:after{height:4.6875vw}
            .section02 .content02 p:nth-child(1){width:49.53125vw;left:calc(50% - 45.46875vw)}
            .section02 .content02 p:nth-child(2){width:49.375vw;left:calc(50% - 4.0625vw)}
            .section02 .content03 p{width:43.906vw;margin-bottom:3.125vw}
            .section02 .content03 p:nth-child(odd){margin-right:9px}
        }
        @media screen and (min-width:712px){
            .section02 .content02{padding-top:40px}
            .section02 .content02 .detail-img{height:58.9887vw}
            .section02 .content02 .detail-img:after{height:18.9606vw}
            .section02 .content02 p:nth-child(1){width:47.4016vw;left:calc(50% - 44.46875vw)}
            .section02 .content02 p:nth-child(2){width:47.191vw;left:calc(50% - 3.0625vw)}
            .section02 .content03 p{width:28.441vw;margin:0.948vw 1.685vw 0.948vw 0}
            .section02 .content03 p:nth-child(3n){margin-right:0}
        }
        @media screen and (min-width:1280px){
            .section02 .content01{padding:100px 0}
            .section02 .content02{padding-top:120px}
            .section02 .content02 .detail-img{height:840px}
            .section02 .content02 .detail-img:after{height:55px}
            .section02 .content02 p:nth-child(1){width:675px;left:calc(50% - 621px)}
            .section02 .content02 p:nth-child(2){width:672px;left:calc(50% - 55px)}
            .section02 .content03 .detail-img.max-limit{padding:105px 0 55px}
            .section02 .content03 p{width:396px;margin:14px 26px 14px 0}
            .section02 .content03 p:nth-child(3n){margin-right:0}
        }
    /* section03 : Mobile Web */
    .layer-project-detail > .section03{padding-top:0}
    .section03 .content01{position:relative;padding-top:40px;background-color:#fcc440}
    .section03 .content01:before{position:absolute;bottom:0;left:0;content:'';width:100%;background-color:#fff}
    .section03 .content01 .detail-img{position:relative;z-index:10}
    .section03 .content02 .detail-img{display:flex;justify-content:center}
    .section03 .content02 p img{box-shadow:10px 17px 20px 0px rgba(0, 0, 0, 0.2)}
        @media screen and (max-width:711px){
            .section03 .content01:before{height:194px}
            .section03 .content01 .detail-img{margin-top:22px;padding-left:4.68vw}
            .section03 .content01 .detail-img img{width:100%}
            .section03 .content02 .detail-img{flex-wrap:wrap;padding-bottom:50px}
            .section03 .content02 p:nth-child(odd){margin-right:5.9375vw}
            .section03 .content02 p:nth-child(2){margin-top:23.4375vw;margin-bottom:6.25vw}
            .section03 .content02 p:nth-child(3){margin-top:-8.75vw}
            .section03 .content02 p img{width:42.3437vw;max-width:270px}
            .section03 .content03 .detail-img{padding-right:9.375vw}
            .section03 .content03 .detail-img img{position:relative;left:calc(50% - 70.3875vw);width:117.1875vw;max-width:750px}
        }
        @media screen and (min-width:712px){
            .section03 .content01:before{height:177px}
            .section03 .content01 .detail-img{text-align:center;margin-top:-15px}
            .section03 .content01 .detail-img img{width:62.2893vw;max-width:887px}
            .section03 .content02{padding-bottom:75px}
            .section03 .content02 p:nth-child(1),
            .section03 .content02 p:nth-child(4){margin-top:13.48314vw}
            .section03 .content02 p:nth-child(2){margin-top:5.9691vw}
            .section03 .content02 p img{width:18.9606vw;max-width:270px;margin:0 1.8255vw}
            .section03 .content03 .detail-img img{position:relative;left:calc(50% - 494px);width:855px;max-width:1700px}
        }
        @media screen and (min-width:1280px){
            .section03 .content01{padding-top:105px}
            .section03 .content01:before{height:317px}
            .section03 .content01 .detail-img{margin-top:-95px}
            .section03 .content02{padding-bottom:150px}
            .section03 .content02 p:nth-child(1),
            .section03 .content02 p:nth-child(4){margin-top:192px}
            .section03 .content02 p:nth-child(2){margin-top:85px}
            .section03 .content02 p img{width:270px;margin:0 26px;box-shadow:20px 36px 40px 0px rgba(0, 0, 0, 0.2)}
            .section03 .content03 .detail-img{padding-bottom:110px}
            .section03 .content03 .detail-img img{position:relative;left:calc(50% - 855px);width:2002px}
        }
    /* section04 : Design Identity */
    .section04{background-color:#f2f1ee}
    .section04 .cont-tit{border-bottom:1px solid #ccc}
    .section04 .cont-desc{color:#666}
    .section04 ul{display:flex;justify-content:flex-end;align-items:center;flex-wrap:wrap}
    .section04 ul li{display:block;border-radius:50%;text-align:center;letter-spacing:0.5px;color:#fff;width:65px;height:65px;line-height:65px}
    .section04 ul li[data-color="#ffc72c"]{background-color:#ffc72c;color:#222}
    .section04 ul li[data-color="#ff5c46"]{background-color:#ff5c46}
    .section04 ul li[data-color="#4567ad"]{background-color:#4567ad}
    .section04 ul li[data-color="#222222"]{background-color:#222222}
    .section04 ul li[data-color="#555555"]{background-color:#555555}
    .section04 ul li[data-color="#777777"]{background-color:#777777}
        @media screen and (max-width:711px){
            .section04 .cont-tit{margin-bottom:12px;padding-bottom:16px}
            .section04 .cont-tit img{width:60.78125vw;max-width:389px}
            .section04 .detail-cont{margin-top:33px}
            .section04 ul{justify-content:center}
            .section04 ul li{margin:7px 4.375vw;font-size:12px}
        }
        @media screen and (min-width:712px){
            .section04 .inner-section{display:flex;justify-content:space-between;align-items:center}
            .section04 .inner-section > * {width:50%}
            .section04 .cont-tit{margin-bottom:12px;padding-bottom:17px}
            .section04 .cont-tit img{width:27.3174vw;max-width:389px}
            .section04 ul li{margin:15px 1.9311vw;font-size:12px}
        }
        @media screen and (min-width:1280px){
            .section04 .inner-section.max-limit{padding:100px 20px}
            .section04 .cont-tit{margin-bottom:30px;padding-bottom:35px}
            .section04 .cont-tit img{width:auto;max-width:544px}
            .section04 .cont-desc{line-height:28px}
            .section04 ul li{margin:20px 0 20px 100px;font-size:15px}
            .section04 ul li{width:100px;height:100px;line-height:100px}
        }
</style>


// WEBPACK FOOTER //
// src/projects/yb-tour.vue